import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { CurrentUserReducer, RootReducer } from '../../models/Redux';

const useIsUserLoggedIn = (): boolean => {
    const [isUserLoggedIn, setIsUserLoggedIn] = useState<boolean>(false);
    const currentUser = useSelector<RootReducer, CurrentUserReducer>(state => state.currentUser);

    useEffect(() => {
        if (Object.keys(currentUser.user).length > 0) {
            setIsUserLoggedIn(true);
        } else {
            setIsUserLoggedIn(false);
        }
    }, [currentUser]);

    return isUserLoggedIn;
};

export default useIsUserLoggedIn;
